import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { appSettingsSlice, AppSettingsSlice } from "./app-settings-slice";

/* Store Types */
export type StoreState = AppSettingsSlice;
export type Middleware = [["zustand/devtools", never], ["zustand/immer", never]];

/*
 * useGlobalStore
 * We use a single Zustand store for any global state used in the app.
 * This store is composed of multiple slices, each slice is a separate state object.
 * Two middleware are used: devtools and immer.
 */
export const useGlobalStore = create<StoreState>()(
  devtools(
    immer((...a) => ({
      ...appSettingsSlice(...a),
    })),
    { name: "Global Store" },
  ),
);
